export interface ISelectedCalendarDate {
  scroll: boolean
  date?: Date
  activeAdvisors: boolean
  cleared?: boolean
}
